export const environment = {
  gaTracker: '',
  withSw: true,
  oktaConfig: {
    additionalScopes: ['api.warp'],
    clientId: '2-b-warp-ui-UJ20A2MIJ5L6OIZ',
    errorPath: '/error',
    tenantId: 'aus3v6rg3e9zNHMxe0x6',
    url: 'https://gem-beta.oktapreview.com',
    withPath: true,
  },
  production: false,
  storagePrefix: 'warp-dev-',
  urlWarp: window.location.protocol + '//api.' + window.location.hostname,
  wsXbar: 'wss://crossbario.spaas-dev.gem.myengie.com/ws',
  wsXbarPrefix: 'cb.preprod',
};
